import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Reviews } from './components/Reviews';
import { TargetAudience } from './components/TargetAudience';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { ProfessionalPlan } from './components/ProfessionalPlan';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-navy flex flex-col font-sans selection:bg-emerald selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Reviews data-id="element-4" />
        <TargetAudience data-id="element-5" />
        <Problem data-id="element-6" />
        <Tomos data-id="element-7" />
        <Bonos data-id="element-8" />
        <Comparison data-id="element-9" />
        <ProfessionalPlan data-id="element-10" />
        <Pricing data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <PurchasePopup data-id="element-16" />
    </div>;
}